import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/* Router Modules */
import boardsRouter from './modules/board'
/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/tv',
    component: () => import('@/views/boards/main'),
    hidden: true
  },
    {
        path: '/tvv',
        component: Layout,
        children: [
        {
            path: '/tvview',
            component: () => import('@/views/boards/main'),
            hidden: true
        },
      ]
    },
  {
    path: '/auth-redirect',
    component: () => import('@/views/login/auth-redirect'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true
  },
{
    path: '/profile',
    component: Layout,
    redirect: '/profile/index',
    hidden: true,
    children: [
    {
        path: 'index',
        component: () => import('@/views/profile/index'),
        name: 'Profile',
        meta: { title: 'Profile', icon: 'user', noCache: true }
    }
    ]
},
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/dashboard/index'),
        name: '首页',
        meta: { title: '首页', icon: 'dashboard', affix: true }
      }
    ]
  }
]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [
    {
        path: '/baseinfo',
        component: Layout,
        redirect: '/baseinfo/accountlist',
        alwaysShow: true, // will always show the root menu
        name: 'baseinfo',
        meta: {
            title: '基础资料',
            icon: 'guide'
        },
        children: [
            {
                path: 'accountlist',
                component: () => import('@/views/account/accountlist'),
                name: 'AccountList',
                meta: {
                title: '用户列表'
                }
            },
            {
                path: 'deptment',
                component: () => import('@/views/baseinfo/deptment'),
                name: 'Deptment',
                meta: {
                title: '部门列表'
                }
            },
        ]
    },
    {
        path: '/hep2',
        component: Layout,
        redirect: '/hep2/ProduceFlow',
        alwaysShow: true, // will always show the root menu
        name: 'hep2',
        meta: {
            title: '信诺尔+扩展',
            icon: 'hep2'
        },
        children: [
            {
                path: 'ProduceFlow',
                component: () => import('@/views/hep2/produce-flow'),
                name: 'ProduceFlow',
                meta: {
                    title: '生产流程卡'
                }
            }, {
                path: 'AssembleFlow',
                component: () => import('@/views/hep2/produce-flow'),
                name: 'AssembleFlow',
                meta: {
                    title: '组装流程卡'
                }
            }, {
                path: 'ProduceTaskRpt',
                component: () => import('@/views/威珏/producetaskrpt'),
                name: 'ProduceTaskRpt',
                meta: {
                    title: '生产任务报表',
                    noCache: true
                }
            }, {
                path: 'BuyToSale',
                component: () => import('@/views/威珏/BuyApplyToSaleOrder'),
                name: 'BuyToSale',
                meta: {
                    title: '申购转换',
                    config: 'SGSync',
                    noCache: true
                }
            }, {
                path: 'OEMToSale',
                component: () => import('@/views/威珏/BuyApplyToSaleOrder'),
                name: 'OEMToSale',
                meta: {
                    title: '委外转换',
                    config: 'WWSync',
                    noCache: true
                }
            }
        ]
    },
      boardsRouter,
  {
    path: '/setting',
    component: Layout,
    redirect: '/setting/index',
    alwaysShow: true, // will always show the root menu
    name: 'setting',
    meta: {
        title: '系统设置',
        icon: 'setting'
    },
    children: [
        {
            path: 'index',
            component: () => import('@/views/setting/SettingPage'),
            name: 'Setting',
            meta: {
                title: '系统设置'
            }
        }, {
            path: 'Permission',
            component: () => import('@/views/setting/Permission'),
            name: 'Permission',
            meta: {
                title: '权限设置'
            }
        }, {
            path: 'HEP2PDAConfig',
            component: () => import('@/views/hep2/HEP2PDAConfig'),
            name: 'HEP2PDAConfig',
            meta: {
                title: '扫码配置'
            }
        },{
            path: 'HEP2PDAConfigEdit',
            component: () => import('@/views/hep2/HEP2PDAConfigEdit-Back'),
            name: 'HEP2PDAConfig',
            hidden: true,
            meta: {
                title: '扫码配置'
            }
        }, 
        {
            path: 'SyncTable',
            component: () => import('@/views/setting/SyncTable'),
            name: 'SyncTable',
            meta: {
                title: '表格同步'
            }
        }
    ]
},
  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
